import facepaint from 'facepaint';
import { breakpoints, queryForPoint } from 'src/styling/media-queries';

export const maxHeaderMobileScreenBreakpoint = '64rem';
export const mqHeaderDisplay = facepaint([queryForPoint(maxHeaderMobileScreenBreakpoint)]);

export const mqDesktopHeader = facepaint([
  queryForPoint('80rem'),
  queryForPoint(breakpoints.maxLargeDesktopScreen),
]);

export const REDESIGN_HEADER_HEIGHT_CSS_VARIABLE = 'redesign-header-height';
export const currentHeaderHeightPx = () => {
  const heightValue = document.documentElement.style.getPropertyValue(
    `--${REDESIGN_HEADER_HEIGHT_CSS_VARIABLE}`
  );

  return heightValue ? Number(heightValue.split('px')[0]) : 0;
};

// We add an extra pixel padding above the header to handle cases where the browser renderer causes an extra
// pixel spacing above the header to appear
export const HEADER_ADDITIONAL_TOP_PADDING_PX = 1;
